import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createResponsiveStateReducer } from 'redux-responsive';
import { BREAKPOINTS } from '../../theme';

import { sessionConstants } from './session/creator';
import { sessionModuleInitialState } from './session/reducer';
import { spinner } from './spinner/reducer';

const requireModule = require.context('.', true, /\.js$/);

const autoImportedReducers = requireModule
  .keys()
  .reduce((modules, folderName) => {
    // use only reducer.js file
    if (folderName === './reducers.js' || !folderName.includes('/reducer.js')) {
      return modules;
    }

    const importedModule = requireModule(folderName);
    const [moduleName] = folderName.replace(/(\.\/|\.js)/g, '')
      .split('/');

    return {
      ...modules,
      [moduleName]: importedModule.default || importedModule,
    };
  }, {});

const createRootReducers = (history) => (state, action) => {
  let newState = { ...state };

  if (action.type === sessionConstants.USER_LOGOUT) {
  // * INFO: retaining router state, rest of the state is reset when user logouts
    newState = {
      router: state.router,
      session: {
        ...sessionModuleInitialState,
      },
    };
  }
  return combineReducers({
    router: connectRouter(history),
    browser: createResponsiveStateReducer(BREAKPOINTS, {
      infinity: 'XL_DESKTOP',
    }),
    ...autoImportedReducers,
    spinner,
  })(newState, action);
};

export default createRootReducers;
